import axios from "axios";
import { base_url } from "../Auth/BackendAPIUrl";

// Admin preview endpoints are public read-only (the data is admin-managed
// content, no PII). No auth header is sent so the iframe loads cleanly
// even if the admin's session cookie isn't shared with the React origin.

export const fetchQuestionPreview = (questionId) =>
  axios.get(`${base_url}/api/admin/preview/question/${questionId}/`).then((r) => r.data);

export const fetchSectionPreview = (sectionId) =>
  axios.get(`${base_url}/api/admin/preview/section/${sectionId}/`).then((r) => r.data);

export const fetchPackagePreview = (packageId) =>
  axios.get(`${base_url}/api/admin/preview/package/${packageId}/`).then((r) => r.data);
